export default __webpack_public_path__ + "static/media/arrows.cb60a8c8.svg";